/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioWBSAPIModelsPuzzelSpCallsGetDestinationQueueResult,
  RightioWBSAPIModelsPuzzelSpCallsGetDestinationQueueV2Result,
  RightioWBSAPIModelsPuzzelSpCallsGetDestinationQueueV3Result,
  RightioWBSAPIModelsPuzzelSpEventsSetEventResult,
  RightioWBSAPIModelsSPSpAppointmentTimeTypesGetResult,
  RightioWBSAPIModelsSPSpAuditTrailFootprintGetAuditTrailResult,
  RightioWBSAPIModelsSPSpAutoAllocationGetLookupRequest,
  RightioWBSAPIModelsSPSpAutoAllocationGetLookupResult,
  RightioWBSAPIModelsSPSpBoilersGetHeatingTypesResult,
  RightioWBSAPIModelsSPSpBoilersGetManufacturersResult,
  RightioWBSAPIModelsSPSpBookingGetBookingRestrictionRequest,
  RightioWBSAPIModelsSPSpBookingGetBookingRestrictionResult,
  RightioWBSAPIModelsSPSpBookingGetBookingRestrictionsResult,
  RightioWBSAPIModelsSPSpBookingGetLastJobRequest,
  RightioWBSAPIModelsSPSpBookingGetLastJobResult,
  RightioWBSAPIModelsSPSpCallMeBacksCancelEnquiryRequest,
  RightioWBSAPIModelsSPSpCallMeBacksGetCallMeBackResult,
  RightioWBSAPIModelsSPSpCallMeBacksGetNotesResult,
  RightioWBSAPIModelsSPSpCallMeBacksQueuesGetQueueRequest,
  RightioWBSAPIModelsSPSpCallMeBacksQueuesGetQueueResult,
  RightioWBSAPIModelsSPSpCallMeBacksSendEmailRequest,
  RightioWBSAPIModelsSPSpCallMeBacksSendSMSRequest,
  RightioWBSAPIModelsSPSpCallMeBacksSetAsBookedRequest,
  RightioWBSAPIModelsSPSpCallMeBacksSetCalledRequest,
  RightioWBSAPIModelsSPSpCallMeBacksSetFollowUpRequest,
  RightioWBSAPIModelsSPSpCallsGetCurrentCallFive9Result,
  RightioWBSAPIModelsSPSpCallsGetCurrentCallResult,
  RightioWBSAPIModelsSPSpCallsGetDestinationQueueRequest,
  RightioWBSAPIModelsSPSpCallsGetDestinationQueueV2Request,
  RightioWBSAPIModelsSPSpCallsGetDestinationQueueV3Request,
  RightioWBSAPIModelsSPSpDiscountsGetDiscountsResult,
  RightioWBSAPIModelsSPSpEnquiriesQueuesGetQueueRequest,
  RightioWBSAPIModelsSPSpEnquiriesQueuesGetQueueResult,
  RightioWBSAPIModelsSPSpEnquiriesSetJobRequest,
  RightioWBSAPIModelsSPSpEnquiriesSetJobResult,
  RightioWBSAPIModelsSPSpEventsSetEventRequest,
  RightioWBSAPIModelsSPSpJobScriptsGetScriptRequest,
  RightioWBSAPIModelsSPSpJobScriptsGetScriptResult,
  RightioWBSAPIModelsSPSpJobsBookingGetIdRequest,
  RightioWBSAPIModelsSPSpJobsBookingGetIdResult,
  RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult,
  RightioWBSAPIModelsSPSpJobsGetAvailableEngineers2Result,
  RightioWBSAPIModelsSPSpJobsGetHistoryResult,
  RightioWBSAPIModelsSPSpJobsGetJobDetailsResult,
  RightioWBSAPIModelsSPSpJobsGetJobLinkingResult,
  RightioWBSAPIModelsSPSpJobsGetJobNotesResult,
  RightioWBSAPIModelsSPSpJobsGetJobResult,
  RightioWBSAPIModelsSPSpJobsGetNotesResult,
  RightioWBSAPIModelsSPSpJobsGetOptionsResult,
  RightioWBSAPIModelsSPSpJobsGetTasksResult,
  RightioWBSAPIModelsSPSpJobsInitialBookingResult,
  RightioWBSAPIModelsSPSpJobsQuotesGetQuoteResult,
  RightioWBSAPIModelsSPSpJobsSetChargeRequest,
  RightioWBSAPIModelsSPSpJobsSetChargeResult,
  RightioWBSAPIModelsSPSpPropertiesGetBuildingTypesResult,
  RightioWBSAPIModelsSPSpRFGetDepartmentTelephoneDetailsResult,
  RightioWBSAPIModelsSPSpRFTrackFastDataproviderSetDataRequest,
  RightioWBSAPIModelsSPSpRFTrackFastEngineersQueuesAddJobToAllocationQueueRequest,
  RightioWBSAPIModelsSPSpRFTrackFastEngineersQueuesAddJobToAllocationQueueResult,
  RightioWBSAPIModelsSPSpRFTrackFastGetPostcodeResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingRequest,
  RightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetCallTypesRequest,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetCallTypesResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobGroupsResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobTypesRequest,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobTypesResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetPaymentMethodsRequest,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetPaymentMethodsResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetTradesRequest,
  RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetTradesResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsSendRequisitionRequest,
  RightioWBSAPIModelsSPSpRFTrackFastJobsSendRequisitionResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsSetupBookingResult,
  RightioWBSAPIModelsSPSpRFTrackFastJobsUpdateJobRequest,
  RightioWBSAPIModelsSPSpRFTrackFastJobsUpdateJobResult,
  RightioWBSAPIModelsSPSpRFTrackFastLockingAddLockRequest,
  RightioWBSAPIModelsSPSpRFTrackFastLockingGetLockRequest,
  RightioWBSAPIModelsSPSpRFTrackFastLockingGetLockResult,
  RightioWBSAPIModelsSPSpRFTrackFastLockingRemoveLockRequest,
  RightioWBSAPIModelsSPSpRFTrackFastSearchGetSearchRequest,
  RightioWBSAPIModelsSPSpRFTrackFastSearchGetSearchResult,
  RightioWBSAPIModelsSPSpReportsSalesAgentScreen4Result,
  RightioWBSAPIModelsSPSpServiceAgreementsAPIGetCustomerMatchesRequest,
  RightioWBSAPIModelsSPSpServiceAgreementsAPIGetCustomerMatchesResult,
  RightioWBSAPIModelsSPSpServiceAgreementsCheckAvailabilityRequest,
  RightioWBSAPIModelsSPSpServiceAgreementsCheckAvailabilityResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetAvailableOffersResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetIncentiveResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetIncentiveTypesResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetOfferAllocationReasonsResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetPaymentTypesResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetPlanCostAfterOffersResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetPlanCostAfterOffersV2Result,
  RightioWBSAPIModelsSPSpServiceAgreementsGetServiceAgreementForJobResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetTypeBenefitsResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetTypeResult,
  RightioWBSAPIModelsSPSpServiceAgreementsGetTypesResult,
  RightioWBSAPIModelsSPSpServiceAgreementsSetCustomerResult,
  RightioWBSAPIModelsSPSpServiceAgreementsSetServiceAgreementV4Result,
  RightioWBSAPIModelsSPSpServiceAgreementsSetServiceAgreementV5Result,
  RightioWBSAPIModelsSPSpServiceAgreementsValidateCampaignCodeResult,
  RightioWBSAPIModelsSPSpSettingsGetSettingResult,
  RightioWBSAPIModelsSPSpTimeRequirementTypesGetResult,
  RightioWBSAPIModelsSPSpTrackFastAddressBlacklistCheckRequest,
  RightioWBSAPIModelsSPSpTrackFastAddressBlacklistCheckResult,
  RightioWBSAPIModelsSPSpTrackFastJobsGetCallerResult,
  RightioWBSAPIModelsSPSpTradesGetJobTypeGroupsResult,
  RightioWBSAPIModelsSPSpUsersGetStatisticsRequest,
  RightioWBSAPIModelsSPSpUsersGetStatisticsResult,
  RightioWBSAPIModelsSPSpUsersManagersAuthorisationRequest,
  RightioWBSAPIModelsSPSpUsersManagersAuthorisationResult,
  RightioWBSAPIModelsSPWebBookingGetTop5CallsResult,
  RightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersRequest,
  RightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersV2Request,
  RightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersRequest,
  RightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersV2Request,
  RightioWBSAPIModelsSpServiceAgreementsGetTypesRequest,
  RightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV4Request,
  RightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV5Request,
  RightioWBSAPIModelsSpServiceAgreementsValidateCampaignCodeRequest,
  RightioWBSAPIModelsUdtUdtServiceAgreementCustomer,
  StoredProceduresJobsCompletionsGetCompletionsParams,
  StoredProceduresJobsGetAvailableEngineers2Params,
  StoredProceduresJobsGetHistoryParams,
  StoredProceduresJobsGetJobDetailsParams,
  StoredProceduresJobsGetJobLinkingParams,
  StoredProceduresJobsGetJobNotesParams,
  StoredProceduresJobsGetJobParams,
  StoredProceduresJobsGetNotesParams,
  StoredProceduresJobsGetOptionsParams,
  StoredProceduresJobsGetTasksParams,
  StoredProceduresJobsInitialBookingParams,
  StoredProceduresJobsQuotesGetQuoteParams,
  StoredProceduresTrackFastJobsSetupBookingParams
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';
import type { BodyType } from '../../../../../services/DatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Retrieves department telephone contact details for geographic routing and regional customer service coordination based on UK postcode.
 * @summary Get Department Telephone Details
 */
export const storedProceduresGetDepartmentTelephoneDetails = (
    postcode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFGetDepartmentTelephoneDetailsResult[]>(
      {url: `/api/spRF_GetDepartmentTelephoneDetails/${postcode}`, method: 'GET'
    },
      options);
    }
  /**
 * Persists entity data using flexible XML format. Supports both creating new records and updating existing ones with comprehensive audit tracking and validation.
 * @summary Set Data
 */
export const storedProceduresTrackFastDataproviderSetData = (
    rightioWBSAPIModelsSPSpRFTrackFastDataproviderSetDataRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastDataproviderSetDataRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/spRF_TrackFast_Dataprovider_SetData`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastDataproviderSetDataRequest
    },
      options);
    }
  /**
 * Adds a job to an engineer's work allocation queue with departure time scheduling. Validates engineer availability, manages queue priorities, and optionally sends SMS notifications for immediate dispatch requirements.
 * @summary Add Job To Allocation Queue
 */
export const storedProceduresTrackFastEngineersQueuesAddJobToAllocationQueue = (
    rightioWBSAPIModelsSPSpRFTrackFastEngineersQueuesAddJobToAllocationQueueRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastEngineersQueuesAddJobToAllocationQueueRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastEngineersQueuesAddJobToAllocationQueueResult[]>(
      {url: `/api/spRF_TrackFast_Engineers_Queues_AddJobToAllocationQueue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastEngineersQueuesAddJobToAllocationQueueRequest
    },
      options);
    }
  /**
 * Validates and resolves a UK postcode to complete address information including geographic coordinates, service area details, and coverage availability for booking validation.
 * @summary Get address from postcode
 */
export const storedProceduresTrackFastGetPostcode = (
    postcode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastGetPostcodeResult[]>(
      {url: `/api/spRF_TrackFast_GetPostcode/${postcode}`, method: 'GET'
    },
      options);
    }
  /**
 * Calculates comprehensive pricing for a job booking including labor rates, parts costs, VAT, and applicable discounts. Considers geographic pricing variations, time-based rates, and customer-specific pricing agreements.
 * @summary Get Charges for Job
 */
export const storedProceduresTrackFastJobsGetChargesBooking = (
    rightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_GetCharges_Booking`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingRequest
    },
      options);
    }
  /**
 * Retrieves available call types filtered by job type and service group. Returns relevant call classifications for accurate job categorization and proper routing to appropriate specialists.
 * @summary Get call types
 */
export const storedProceduresTrackFastJobsLookupGetCallTypes = (
    rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetCallTypesRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetCallTypesRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetCallTypesResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_Lookup_GetCallTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetCallTypesRequest
    },
      options);
    }
  /**
 * Retrieves hierarchical job groups for trade-specific service categorization and organized workflow management.
 * @summary Get job groups
 */
export const storedProceduresTrackFastJobsLookupGetJobGroups = (
    tradeCode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobGroupsResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_Lookup_GetJobGroups/${tradeCode}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves available job types filtered by customer account, trade specialty, service group, and location. Returns contextually relevant options for accurate service categorization and pricing.
 * @summary Get job types
 */
export const storedProceduresTrackFastJobsLookupGetJobTypes = (
    rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobTypesRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobTypesRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobTypesResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_Lookup_GetJobTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetJobTypesRequest
    },
      options);
    }
  /**
 * Retrieves available payment methods filtered by customer type (commercial/residential) and service category. Returns appropriate payment options for the booking context.
 * @summary Get payment methods
 */
export const storedProceduresTrackFastJobsLookupGetPaymentMethods = (
    rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetPaymentMethodsRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetPaymentMethodsRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetPaymentMethodsResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_Lookup_GetPaymentMethods`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetPaymentMethodsRequest
    },
      options);
    }
  /**
 * Retrieves available trade specialties filtered by service type and customer account. Returns relevant engineering trades for skill-based job assignment and proper service delivery.
 * @summary Get trades
 */
export const storedProceduresTrackFastJobsLookupGetTrades = (
    rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetTradesRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetTradesRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetTradesResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_Lookup_GetTrades`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastJobsLookupGetTradesRequest
    },
      options);
    }
  /**
 * Generates and transmits job requisitions to suppliers for parts procurement and specialized services. Supports multiple delivery methods including email and fax for supply chain communication.
 * @summary Send requisition
 */
export const storedProceduresTrackFastJobsSendRequisition = (
    rightioWBSAPIModelsSPSpRFTrackFastJobsSendRequisitionRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastJobsSendRequisitionRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsSendRequisitionResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_SendRequisition`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastJobsSendRequisitionRequest
    },
      options);
    }
  /**
 * Initializes a new job booking by retrieving account details, call type configurations, and pre-assigned engineer information. Returns essential data needed to proceed with job creation including account type, description, and any auto-allocated engineer.
 * @summary Setup new Job
 */
export const storedProceduresTrackFastJobsSetupBooking = (
    params?: StoredProceduresTrackFastJobsSetupBookingParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsSetupBookingResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_SetupBooking`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Performs comprehensive update of job details including customer information, appointment scheduling, service specifications, and pricing. Validates all changes and maintains audit trail for compliance and tracking purposes.
 * @summary Update Job
 */
export const storedProceduresTrackFastJobsUpdateJob = (
    rightioWBSAPIModelsSPSpRFTrackFastJobsUpdateJobRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastJobsUpdateJobRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastJobsUpdateJobResult[]>(
      {url: `/api/spRF_TrackFast_Jobs_UpdateJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastJobsUpdateJobRequest
    },
      options);
    }
  /**
 * Creates an exclusive lock on a specific record to prevent concurrent editing conflicts. Returns lock ID if successful or conflict information if record is already locked by another user.
 * @summary Add Lock
 */
export const storedProceduresTrackFastLockingAddLock = (
    rightioWBSAPIModelsSPSpRFTrackFastLockingAddLockRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastLockingAddLockRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/spRF_TrackFast_Locking_AddLock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastLockingAddLockRequest
    },
      options);
    }
  /**
 * Retrieves current lock status for a specific record including lock owner, timestamp, and duration information. Returns empty result if record is not locked.
 * @summary Get lock
 */
export const storedProceduresTrackFastLockingGetLock = (
    rightioWBSAPIModelsSPSpRFTrackFastLockingGetLockRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastLockingGetLockRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastLockingGetLockResult[]>(
      {url: `/api/spRF_TrackFast_Locking_GetLock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastLockingGetLockRequest
    },
      options);
    }
  /**
 * Releases an exclusive lock on a specific record, making it available for editing by other users. Essential for proper concurrency control when users finish editing or sessions end.
 * @summary Remove Lock
 */
export const storedProceduresTrackFastLockingRemoveLock = (
    rightioWBSAPIModelsSPSpRFTrackFastLockingRemoveLockRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastLockingRemoveLockRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/spRF_TrackFast_Locking_RemoveLock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastLockingRemoveLockRequest
    },
      options);
    }
  /**
 * Searches across multiple entities including jobs, customers, and addresses. Supports partial matching on names, postcodes, phone numbers, and job references with optional time-based filtering to focus on recent records.
 * @summary Get Search Result
 */
export const storedProceduresTrackFastSearchGetSearchResult = (
    rightioWBSAPIModelsSPSpRFTrackFastSearchGetSearchRequest: BodyType<RightioWBSAPIModelsSPSpRFTrackFastSearchGetSearchRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpRFTrackFastSearchGetSearchResult[]>(
      {url: `/api/spRF_TrackFast_Search_GetSearch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpRFTrackFastSearchGetSearchRequest
    },
      options);
    }
  /**
 * Retrieves all appointment time type definitions for scheduling flexibility and customer convenience options.
 * @summary Gets all AppointmentTimeTypes
 */
export const storedProceduresAppointmentTimeTypesGet = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpAppointmentTimeTypesGetResult[]>(
      {url: `/api/sp_AppointmentTimeTypes_Get`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves chronological audit trail showing all actions, changes, and events for a specific job. Includes user details, timestamps, and before/after values for comprehensive tracking and compliance.
 * @summary Get Audit Trail Footprint for a Job
 */
export const storedProceduresAuditTrailFootprintGetAuditTrail = (
    jobId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpAuditTrailFootprintGetAuditTrailResult[]>(
      {url: `/api/sp_AuditTrailFootprint_GetAuditTrail/${jobId}`, method: 'GET'
    },
      options);
    }
  /**
 * Validates automatic job allocation eligibility for intelligent engineer assignment and resource optimization based on multiple criteria.
 * @summary Checks if a job can be auto allocated
 */
export const storedProceduresAutoAllocationGetLookup = (
    rightioWBSAPIModelsSPSpAutoAllocationGetLookupRequest: BodyType<RightioWBSAPIModelsSPSpAutoAllocationGetLookupRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpAutoAllocationGetLookupResult[]>(
      {url: `/api/sp_AutoAllocation_GetLookup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpAutoAllocationGetLookupRequest
    },
      options);
    }
  /**
 * Retrieves comprehensive list of heating system types for equipment categorization, service specialization, and engineer skill matching in heating and boiler services.
 * @summary Get all Heating Types
 */
export const storedProceduresBoilersGetHeatingTypes = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpBoilersGetHeatingTypesResult[]>(
      {url: `/api/sp_Boilers_GetHeatingTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves comprehensive list of boiler and heating equipment manufacturers for parts identification, warranty management, and manufacturer-specific service procedures.
 * @summary Get all Manufacturers
 */
export const storedProceduresBoilersGetManufacturers = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpBoilersGetManufacturersResult[]>(
      {url: `/api/sp_Boilers_GetManufacturers`, method: 'GET'
    },
      options);
    }
  /**
 * Validates booking request against business rules including geographic coverage, engineer availability, account limitations, service restrictions, and scheduling constraints. Returns restriction status and any applicable limitations.
 * @summary Get booking restriction for a set of parameters
 */
export const storedProceduresBookingGetBookingRestriction = (
    rightioWBSAPIModelsSPSpBookingGetBookingRestrictionRequest: BodyType<RightioWBSAPIModelsSPSpBookingGetBookingRestrictionRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpBookingGetBookingRestrictionResult[]>(
      {url: `/api/sp_Booking_GetBookingRestriction`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpBookingGetBookingRestrictionRequest
    },
      options);
    }
  /**
 * Retrieves all booking restrictions for scheduling constraints and operational compliance enforcement.
 * @summary Get all booking restrictions
 */
export const storedProceduresBookingGetBookingRestrictions = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpBookingGetBookingRestrictionsResult[]>(
      {url: `/api/sp_Booking_GetBookingRestrictions`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves the most recent job information for customer context and service continuity based on multiple criteria.
 * @summary Get last job result for a set of parameters
 */
export const storedProceduresBookingGetLastJob = (
    rightioWBSAPIModelsSPSpBookingGetLastJobRequest: BodyType<RightioWBSAPIModelsSPSpBookingGetLastJobRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpBookingGetLastJobResult[]>(
      {url: `/api/sp_Booking_GetLastJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpBookingGetLastJobRequest
    },
      options);
    }
  /**
 * Cancels callback enquiries with optional customer contact for professional closure and workflow management.
 * @summary Cancel CallMeBack enquiry
 */
export const storedProceduresCallMeBacksCancelEnquiry = (
    rightioWBSAPIModelsSPSpCallMeBacksCancelEnquiryRequest: BodyType<RightioWBSAPIModelsSPSpCallMeBacksCancelEnquiryRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/sp_CallMeBacks_CancelEnquiry`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallMeBacksCancelEnquiryRequest
    },
      options);
    }
  /**
 * Retrieves callback request details for customer service management and lead processing workflows.
 * @summary Get CallMeBack by LeadId
 */
export const storedProceduresCallMeBacksGetCallMeBack = (
    leadId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpCallMeBacksGetCallMeBackResult[]>(
      {url: `/api/sp_CallMeBacks_GetCallMeBack/${leadId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves callback notes and communication history for customer service context and interaction tracking.
 * @summary Get CallMeBack Notes by LeadId
 */
export const storedProceduresCallMeBacksGetNotes = (
    leadId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpCallMeBacksGetNotesResult[]>(
      {url: `/api/sp_CallMeBacks_GetNotes/${leadId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves pending callback requests from the queue filtered by lead source and time range. Returns customer contact details, preferred callback times, and inquiry information for agent action.
 * @summary Get CallMeBacks Queue by LeadId and DateTimeFrom
 */
export const storedProceduresCallMeBacksQueuesGetQueue = (
    rightioWBSAPIModelsSPSpCallMeBacksQueuesGetQueueRequest: BodyType<RightioWBSAPIModelsSPSpCallMeBacksQueuesGetQueueRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpCallMeBacksQueuesGetQueueResult[]>(
      {url: `/api/sp_CallMeBacks_Queues_GetQueue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallMeBacksQueuesGetQueueRequest
    },
      options);
    }
  /**
 * Sends automated email communication for callback requests including confirmations, updates, and follow-up messages to maintain customer engagement and service quality.
 * @summary Send CallMeBack email
 */
export const storedProceduresCallMeBacksSendEmail = (
    rightioWBSAPIModelsSPSpCallMeBacksSendEmailRequest: BodyType<RightioWBSAPIModelsSPSpCallMeBacksSendEmailRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/sp_CallMeBacks_SendEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallMeBacksSendEmailRequest
    },
      options);
    }
  /**
 * Sends SMS notification for callback requests providing immediate customer acknowledgment and maintaining engagement through mobile communication channels for enhanced service experience.
 * @summary Send CallMeBack SMS
 */
export const storedProceduresCallMeBacksSendSMS = (
    rightioWBSAPIModelsSPSpCallMeBacksSendSMSRequest: BodyType<RightioWBSAPIModelsSPSpCallMeBacksSendSMSRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/sp_CallMeBacks_SendSMS`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallMeBacksSendSMSRequest
    },
      options);
    }
  /**
 * Marks a callback request as successfully converted to a booking, updating workflow status and enabling conversion tracking for sales performance analysis.
 * @summary Set CallMeBack as booked
 */
export const storedProceduresCallMeBacksSetAsBooked = (
    rightioWBSAPIModelsSPSpCallMeBacksSetAsBookedRequest: BodyType<RightioWBSAPIModelsSPSpCallMeBacksSetAsBookedRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/sp_CallMeBacks_SetAsBooked`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallMeBacksSetAsBookedRequest
    },
      options);
    }
  /**
 * Marks callback requests as contacted for workflow tracking and agent accountability.
 * @summary Set Called for CallMeBacks by LeadId
 */
export const storedProceduresCallMeBacksSetCalled = (
    rightioWBSAPIModelsSPSpCallMeBacksSetCalledRequest: BodyType<RightioWBSAPIModelsSPSpCallMeBacksSetCalledRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/sp_CallMeBacks_SetCalled`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallMeBacksSetCalledRequest
    },
      options);
    }
  /**
 * Schedules callback follow-ups for systematic customer relationship management and service continuity.
 * @summary Set CallMeBack as FollowUp
 */
export const storedProceduresCallMeBacksSetFollowUp = (
    rightioWBSAPIModelsSPSpCallMeBacksSetFollowUpRequest: BodyType<RightioWBSAPIModelsSPSpCallMeBacksSetFollowUpRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<number>(
      {url: `/api/sp_CallMeBacks_SetFollowUp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallMeBacksSetFollowUpRequest
    },
      options);
    }
  /**
 * Retrieves details of the agent's currently active call including customer information, call duration, type, and related job context for effective call handling and customer service.
 * @summary Gets the current call for a user
 */
export const storedProceduresCallsGetCurrentCall = (
    userId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpCallsGetCurrentCallResult[]>(
      {url: `/api/sp_Calls_GetCurrentCall/${userId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves details of a specific call by its unique call ID and validates it belongs to the specified agent. Marks the call as 'popped' to prevent duplicate processing.
 * @summary Gets the current call by call ID and agent ID
 */
export const storedProceduresCallsGetCurrentCallFive9 = (
    callId: number,
    agentId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpCallsGetCurrentCallFive9Result[]>(
      {url: `/api/sp_Calls_GetCurrentCall_Five9/${callId}/${agentId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves destination queue information for call routing and telephony integration.
 * @summary Get Destination Queue for Calls
 */
export const storedProceduresCallsGetDestinationQueue = (
    rightioWBSAPIModelsSPSpCallsGetDestinationQueueRequest: BodyType<RightioWBSAPIModelsSPSpCallsGetDestinationQueueRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelSpCallsGetDestinationQueueResult[]>(
      {url: `/api/sp_Calls_GetDestinationQueue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallsGetDestinationQueueRequest
    },
      options);
    }
  /**
 * Retrieves enhanced destination queue information for advanced call routing and telephony integration.
 * @summary Get Enhanced Destination Queue for Calls (V2)
 */
export const storedProceduresCallsGetDestinationQueueV2 = (
    rightioWBSAPIModelsSPSpCallsGetDestinationQueueV2Request: BodyType<RightioWBSAPIModelsSPSpCallsGetDestinationQueueV2Request>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelSpCallsGetDestinationQueueV2Result[]>(
      {url: `/api/sp_Calls_GetDestinationQueue_V2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallsGetDestinationQueueV2Request
    },
      options);
    }
  /**
 * Retrieves latest destination queue information for next-generation call routing and telephony integration.
 * @summary Get Latest Destination Queue for Calls (V3)
 */
export const storedProceduresCallsGetDestinationQueueV3 = (
    rightioWBSAPIModelsSPSpCallsGetDestinationQueueV3Request: BodyType<RightioWBSAPIModelsSPSpCallsGetDestinationQueueV3Request>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelSpCallsGetDestinationQueueV3Result[]>(
      {url: `/api/sp_Calls_GetDestinationQueue_v3`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpCallsGetDestinationQueueV3Request
    },
      options);
    }
  /**
 * Retrieves available discounts for pricing optimization and customer value delivery by type.
 * @summary Gets the Discounts for a DiscountTypeId
 */
export const storedProceduresDiscountsGetDiscounts = (
    discountTypeId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpDiscountsGetDiscountsResult[]>(
      {url: `/api/sp_Discounts_GetDiscounts/${discountTypeId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves enquiry queue information for lead management and customer service workflow organization.
 * @summary Get Enquiries Queue by Id and DateTimeFrom
 */
export const storedProceduresEnquiriesQueuesGetQueue = (
    rightioWBSAPIModelsSPSpEnquiriesQueuesGetQueueRequest: BodyType<RightioWBSAPIModelsSPSpEnquiriesQueuesGetQueueRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpEnquiriesQueuesGetQueueResult[]>(
      {url: `/api/sp_Enquiries_Queues_GetQueue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpEnquiriesQueuesGetQueueRequest
    },
      options);
    }
  /**
 * Converts a customer enquiry into a confirmed job, updating workflow status and initiating service delivery processes for successful lead conversion.
 * @summary Set Enquiry as Job
 */
export const storedProceduresEnquiriesSetJob = (
    rightioWBSAPIModelsSPSpEnquiriesSetJobRequest: BodyType<RightioWBSAPIModelsSPSpEnquiriesSetJobRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpEnquiriesSetJobResult[]>(
      {url: `/api/sp_Enquiries_SetJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpEnquiriesSetJobRequest
    },
      options);
    }
  /**
 * Records telephony events for call tracking, monitoring, and system integration.
 * @summary Set Event for Telephony Tracking
 */
export const storedProceduresEventsSetEvent = (
    rightioWBSAPIModelsSPSpEventsSetEventRequest: BodyType<RightioWBSAPIModelsSPSpEventsSetEventRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelSpEventsSetEventResult[]>(
      {url: `/api/sp_Events_SetEvent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpEventsSetEventRequest
    },
      options);
    }
  /**
 * Retrieves context-specific job scripts for standardized customer service and professional communication.
 * @summary Get Script for Job
 */
export const storedProceduresJobScriptsGetScript = (
    rightioWBSAPIModelsSPSpJobScriptsGetScriptRequest: BodyType<RightioWBSAPIModelsSPSpJobScriptsGetScriptRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobScriptsGetScriptResult[]>(
      {url: `/api/sp_JobScripts_GetScript`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpJobScriptsGetScriptRequest
    },
      options);
    }
  /**
 * Generates a new job ID and creates an initial job record in the system. This stored procedure is the entry point for the job booking process, establishing the job with initial tracking and source information.
 * @summary Create a new Job
 */
export const storedProceduresJobsBookingGetId = (
    rightioWBSAPIModelsSPSpJobsBookingGetIdRequest: BodyType<RightioWBSAPIModelsSPSpJobsBookingGetIdRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsBookingGetIdResult[]>(
      {url: `/api/sp_Jobs_Booking_GetId`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpJobsBookingGetIdRequest
    },
      options);
    }
  /**
 * Retrieves detailed completion information for a job including work performed, materials used, time spent, customer satisfaction scores, and billing details for quality assurance and follow-up.
 * @summary Get Completions by JobId
 */
export const storedProceduresJobsCompletionsGetCompletions = (
    params: StoredProceduresJobsCompletionsGetCompletionsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult[]>(
      {url: `/api/sp_Jobs_Completions_GetCompletions`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves a list of engineers available for job allocation, sorted by suitability based on skills match, proximity, current workload, and availability. Includes distance calculations and estimated travel times for dispatch optimization.
 * @summary Get Available Engineers by JobId
 */
export const storedProceduresJobsGetAvailableEngineers2 = (
    params: StoredProceduresJobsGetAvailableEngineers2Params,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetAvailableEngineers2Result[]>(
      {url: `/api/sp_Jobs_GetAvailableEngineers2`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves chronological history of job events including status changes, engineer assignments, appointment modifications, and system updates for comprehensive lifecycle tracking and SLA monitoring.
 * @summary Get History by JobId
 */
export const storedProceduresJobsGetHistory = (
    params: StoredProceduresJobsGetHistoryParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetHistoryResult[]>(
      {url: `/api/sp_Jobs_GetHistory`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves comprehensive job information including customer details, property information, engineer assignment, pricing, payment status, and service agreement associations.
 * @summary Get Job by JobId
 */
export const storedProceduresJobsGetJob = (
    params?: StoredProceduresJobsGetJobParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetJobResult[]>(
      {url: `/api/sp_Jobs_GetJob`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves comprehensive job information including customer data, service details, engineer assignment, pricing, payment methods, and current status. Essential for job management and customer service operations.
 * @summary Get Job Details by JobId
 */
export const storedProceduresJobsGetJobDetails = (
    params: StoredProceduresJobsGetJobDetailsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetJobDetailsResult[]>(
      {url: `/api/sp_Jobs_GetJobDetails`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves job relationship links for multi-visit service coordination and comprehensive service management.
 * @summary Get all links for a Job
 */
export const storedProceduresJobsGetJobLinking = (
    params?: StoredProceduresJobsGetJobLinkingParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetJobLinkingResult[]>(
      {url: `/api/sp_Jobs_GetJobLinking`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves job-specific notes and communication history for service context and workflow continuity.
 * @summary Get Job Notes by JobId
 */
export const storedProceduresJobsGetJobNotes = (
    params?: StoredProceduresJobsGetJobNotesParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetJobNotesResult[]>(
      {url: `/api/sp_Jobs_GetJobNotes`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves chronological notes, comments, and communication logs for a job. Includes customer interactions, engineer feedback, and system-generated messages for complete job context.
 * @summary Get Notes by JobId
 */
export const storedProceduresJobsGetNotes = (
    params: StoredProceduresJobsGetNotesParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetNotesResult[]>(
      {url: `/api/sp_Jobs_GetNotes`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves job-specific options and configurations for service customization and workflow flexibility.
 * @summary Get Job Options by JobId
 */
export const storedProceduresJobsGetOptions = (
    params?: StoredProceduresJobsGetOptionsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetOptionsResult[]>(
      {url: `/api/sp_Jobs_GetOptions`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves job-specific tasks for work breakdown and engineer guidance.
 * @summary Get Tasks by JobId
 */
export const storedProceduresJobsGetTasks = (
    params?: StoredProceduresJobsGetTasksParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsGetTasksResult[]>(
      {url: `/api/sp_Jobs_GetTasks`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Initializes booking process for a job by preparing customer data, validating service requirements, and setting up default values for efficient job creation and confirmation.
 * @summary Setup Booking with JobId
 */
export const storedProceduresJobsInitialBooking = (
    params: StoredProceduresJobsInitialBookingParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsInitialBookingResult[]>(
      {url: `/api/sp_Jobs_InitialBooking`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves job quote information for customer pricing transparency and approval workflows.
 * @summary Get Quote for Job by JobId
 */
export const storedProceduresJobsQuotesGetQuote = (
    params?: StoredProceduresJobsQuotesGetQuoteParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsQuotesGetQuoteResult[]>(
      {url: `/api/sp_Jobs_Quotes_GetQuote`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Sets comprehensive job charging information for accurate billing and revenue management with full calculation support.
 * @summary Set Charge for Job by JobId
 */
export const storedProceduresJobsSetCharge = (
    rightioWBSAPIModelsSPSpJobsSetChargeRequest: BodyType<RightioWBSAPIModelsSPSpJobsSetChargeRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpJobsSetChargeResult[]>(
      {url: `/api/sp_Jobs_SetCharge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpJobsSetChargeRequest
    },
      options);
    }
  /**
 * Retrieves all building type classifications for property categorization and service planning.
 * @summary Get Building Types
 */
export const storedProceduresPropertiesGetBuildingTypes = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpPropertiesGetBuildingTypesResult[]>(
      {url: `/api/sp_Properties_GetBuildingTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all holding jobs for sales agent monitoring and follow-up management.
 * @summary Gets all Holding Jobs
 */
export const storedProceduresReportsSalesAgentScreen4Get = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpReportsSalesAgentScreen4Result[]>(
      {url: `/api/sp_Reports_SalesAgentScreen4_Get`, method: 'GET'
    },
      options);
    }
  /**
 * Searches for existing customer matches to prevent duplicates and maintain data integrity using multiple identification criteria.
 * @summary Search for Customer Matches
 */
export const storedProceduresServiceAgreementsAPIGetCustomerMatches = (
    rightioWBSAPIModelsSPSpServiceAgreementsAPIGetCustomerMatchesRequest: BodyType<RightioWBSAPIModelsSPSpServiceAgreementsAPIGetCustomerMatchesRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsAPIGetCustomerMatchesResult[]>(
      {url: `/api/sp_ServiceAgreements_API_GetCustomerMatches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpServiceAgreementsAPIGetCustomerMatchesRequest
    },
      options);
    }
  /**
 * Validates whether a service agreement can be offered based on equipment age, geographic coverage, and service type. Returns availability status and any restrictions that may apply to the coverage.
 * @summary Check coverage for service agreement
 */
export const storedProceduresServiceAgreementsCheckAvailability = (
    rightioWBSAPIModelsSPSpServiceAgreementsCheckAvailabilityRequest: BodyType<RightioWBSAPIModelsSPSpServiceAgreementsCheckAvailabilityRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsCheckAvailabilityResult[]>(
      {url: `/api/sp_ServiceAgreements_CheckAvailability`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpServiceAgreementsCheckAvailabilityRequest
    },
      options);
    }
  /**
 * Retrieves personalized promotional offers and discounts available for a service agreement based on customer profile, contract terms, and active campaigns. Returns targeted offers to maximize conversion while maintaining profitability.
 * @summary Get available offers for service agreement
 */
export const storedProceduresServiceAgreementsGetAvailableOffers = (
    rightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersRequest: BodyType<RightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetAvailableOffersResult[]>(
      {url: `/api/sp_ServiceAgreements_GetAvailableOffers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersRequest
    },
      options);
    }
  /**
 * Retrieves available service agreement offers with enhanced filtering for personalized sales strategies based on comprehensive criteria.
 * @summary Get available offers for service agreement
 */
export const storedProceduresServiceAgreementsGetAvailableOffersV2 = (
    rightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersV2Request: BodyType<RightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersV2Request>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetAvailableOffersResult[]>(
      {url: `/api/sp_ServiceAgreements_GetAvailableOffersV2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsGetAvailableOffersV2Request
    },
      options);
    }
  /**
 * Retrieves specific incentive details for service agreement management and offer tracking.
 * @summary Get incentive for service agreement by id
 */
export const storedProceduresServiceAgreementsGetIncentive = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetIncentiveResult[]>(
      {url: `/api/sp_ServiceAgreements_GetIncentive/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves available incentive types for service agreement sales and customer acquisition strategies.
 * @summary Get incentive types for service agreement type
 */
export const storedProceduresServiceAgreementsGetIncentiveTypes = (
    serviceAgreementTypeId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetIncentiveTypesResult[]>(
      {url: `/api/sp_ServiceAgreements_GetIncentiveTypes/${serviceAgreementTypeId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves offer allocation reasons for sales tracking and campaign performance analysis.
 * @summary Get Offer Allocation Reasons
 */
export const storedProceduresServiceAgreementsGetOfferAllocationReasons = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetOfferAllocationReasonsResult[]>(
      {url: `/api/sp_ServiceAgreements_GetOfferAllocationReasons`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all available payment types for service agreement flexibility and customer convenience.
 * @summary Get Payment Types
 */
export const storedProceduresServiceAgreementsGetPaymentTypes = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetPaymentTypesResult[]>(
      {url: `/api/sp_ServiceAgreements_GetPaymentTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Calculates final service agreement pricing after applying promotional offers and discounts. Returns detailed cost breakdown including base price, applied discounts, and final amounts for accurate customer quoting.
 * @summary Get Plan Cost After Offers
 */
export const storedProceduresServiceAgreementsGetPlanCostAfterOffers = (
    rightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersRequest: BodyType<RightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetPlanCostAfterOffersResult[]>(
      {url: `/api/sp_ServiceAgreements_GetPlanCostAfterOffers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersRequest
    },
      options);
    }
  /**
 * Calculates final service agreement costs after applying complex offer combinations and discounts.
 * @summary Get Plan Cost After Offers
 */
export const storedProceduresServiceAgreementsGetPlanCostAfterOffersV2 = (
    rightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersV2Request: BodyType<RightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersV2Request>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetPlanCostAfterOffersV2Result>(
      {url: `/api/sp_ServiceAgreements_GetPlanCostAfterOffers_v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsGetPlanCostAfterOffersV2Request
    },
      options);
    }
  /**
 * Retrieves service agreement coverage information for job authorization and billing determination.
 * @summary Get Service Agreement For Job
 */
export const storedProceduresServiceAgreementsGetServiceAgreementForJob = (
    jobId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetServiceAgreementForJobResult[]>(
      {url: `/api/sp_ServiceAgreements_GetServiceAgreementForJob/${jobId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves service agreement type benefits for customer value communication and sales enablement.
 * @summary Get benefits types
 */
export const storedProceduresServiceAgreementsGetTypeBenefits = (
    serviceAgreementTypeId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetTypeBenefitsResult[]>(
      {url: `/api/sp_ServiceAgreements_GetTypeBenefits/${serviceAgreementTypeId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves specific service agreement type details for configuration and sales processes.
 * @summary Get Service Agreement Type by Id
 */
export const storedProceduresServiceAgreementsGetType = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetTypeResult[]>(
      {url: `/api/sp_ServiceAgreements_GetType/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves available service agreement types based on pricing model, discount codes, and type category. Returns comprehensive plan details including pricing, coverage, and eligibility.
 * @summary Get Service Agreement Types matching the search criteria
 */
export const storedProceduresServiceAgreementsGetTypes = (
    rightioWBSAPIModelsSpServiceAgreementsGetTypesRequest: BodyType<RightioWBSAPIModelsSpServiceAgreementsGetTypesRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsGetTypesResult[]>(
      {url: `/api/sp_ServiceAgreements_GetTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsGetTypesRequest
    },
      options);
    }
  /**
 * Creates or updates customer information for service agreement management with comprehensive validation.
 * @summary Setup new Service Agreement Customer
 */
export const storedProceduresServiceAgreementsSetCustomer = (
    rightioWBSAPIModelsUdtUdtServiceAgreementCustomer: BodyType<RightioWBSAPIModelsUdtUdtServiceAgreementCustomer>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsSetCustomerResult>(
      {url: `/api/sp_ServiceAgreements_SetCustomer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsUdtUdtServiceAgreementCustomer
    },
      options);
    }
  /**
 * Creates a comprehensive service agreement with customer information, multiple address types, payment details, and promotional offers. Validates all data, processes payments, and optionally sends confirmation emails.
 * @summary Setup new Service Agreement
 */
export const storedProceduresServiceAgreementsSetServiceAgreementV4 = (
    rightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV4Request: BodyType<RightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV4Request>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsSetServiceAgreementV4Result[]>(
      {url: `/api/sp_ServiceAgreements_SetServiceAgreement_v4`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV4Request
    },
      options);
    }
  /**
 * Creates a complete service agreement with customer details, addresses, payment methods, and applied offers. Returns the generated agreement reference number.
 * @summary Setup new Service Agreement
 */
export const storedProceduresServiceAgreementsSetServiceAgreementV5 = (
    rightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV5Request: BodyType<RightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV5Request>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsSetServiceAgreementV5Result>(
      {url: `/api/sp_ServiceAgreements_SetServiceAgreement_v5`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsSetServiceAgreementV5Request
    },
      options);
    }
  /**
 * Validates campaign codes for promotional offers and marketing attribution with comprehensive eligibility checking.
 * @summary Validate Campaign Code
 */
export const storedProceduresServiceAgreementsValidateCampaignCode = (
    rightioWBSAPIModelsSpServiceAgreementsValidateCampaignCodeRequest: BodyType<RightioWBSAPIModelsSpServiceAgreementsValidateCampaignCodeRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpServiceAgreementsValidateCampaignCodeResult[]>(
      {url: `/api/sp_ServiceAgreements_ValidateCampaignCode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSpServiceAgreementsValidateCampaignCodeRequest
    },
      options);
    }
  /**
 * Retrieves specific system configuration setting by name. Returns setting value and metadata for application behavior control and business rule management.
 * @summary Get Setting
 */
export const storedProceduresSettingsGetSetting = (
    settingName: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpSettingsGetSettingResult[]>(
      {url: `/api/sp_Settings_GetSetting/${settingName}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves account-specific time requirement types for customized service scheduling.
 * @summary Get Time Requirement Types for Account
 */
export const storedProceduresTimeRequirementTypesGet = (
    accountCode: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpTimeRequirementTypesGetResult[]>(
      {url: `/api/sp_TimeRequirementTypes_Get/${accountCode}`, method: 'GET'
    },
      options);
    }
  /**
 * Validates addresses against service delivery restrictions for safety and risk management.
 * @summary Check if Address is Blacklisted
 */
export const storedProceduresTrackFastAddressBlacklistCheck = (
    rightioWBSAPIModelsSPSpTrackFastAddressBlacklistCheckRequest: BodyType<RightioWBSAPIModelsSPSpTrackFastAddressBlacklistCheckRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpTrackFastAddressBlacklistCheckResult[]>(
      {url: `/api/sp_TrackFast_Address_Blacklist_Check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpTrackFastAddressBlacklistCheckRequest
    },
      options);
    }
  /**
 * Retrieves caller information for job context and customer communication.
 * @summary Get Caller Details for Job
 */
export const storedProceduresTrackFastJobsGetCaller = (
    jobId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpTrackFastJobsGetCallerResult[]>(
      {url: `/api/sp_TrackFast_Jobs_GetCaller/${jobId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves job type groups for trade-specific service organization and workflow management.
 * @summary Get Job Type Groups
 */
export const storedProceduresTradesGetJobTypeGroups = (
    tradeCode: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpTradesGetJobTypeGroupsResult[]>(
      {url: `/api/sp_Trades_GetJobTypeGroups/${tradeCode}`, method: 'GET'
    },
      options);
    }
  /**
 * Generates comprehensive performance statistics for a user including job metrics, completion rates, customer satisfaction, and productivity measures over a specified time period.
 * @summary Get Statistics for User
 */
export const storedProceduresUsersGetStatistics = (
    rightioWBSAPIModelsSPSpUsersGetStatisticsRequest: BodyType<RightioWBSAPIModelsSPSpUsersGetStatisticsRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpUsersGetStatisticsResult[]>(
      {url: `/api/sp_Users_GetStatistics`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpUsersGetStatisticsRequest
    },
      options);
    }
  /**
 * Validates manager credentials for sensitive operations requiring supervisory approval. Returns authorization status and manager details for audit trail purposes.
 * @summary Verify authorisation from Manager
 */
export const storedProceduresUsersManagersAuthorisation = (
    rightioWBSAPIModelsSPSpUsersManagersAuthorisationRequest: BodyType<RightioWBSAPIModelsSPSpUsersManagersAuthorisationRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPSpUsersManagersAuthorisationResult[]>(
      {url: `/api/sp_Users_ManagersAuthorisation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSPSpUsersManagersAuthorisationRequest
    },
      options);
    }
  /**
 * Retrieves the 5 most recent calls for customer context and service delivery personalization in web booking workflows.
 * @summary Get Top 5 Calls
 */
export const webBookingGetTop5Calls = (
    telephone: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSPWebBookingGetTop5CallsResult[]>(
      {url: `/api/WebBookingGetTop5Calls/${telephone}`, method: 'GET'
    },
      options);
    }
  export type StoredProceduresGetDepartmentTelephoneDetailsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresGetDepartmentTelephoneDetails>>>
export type StoredProceduresTrackFastDataproviderSetDataResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastDataproviderSetData>>>
export type StoredProceduresTrackFastEngineersQueuesAddJobToAllocationQueueResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastEngineersQueuesAddJobToAllocationQueue>>>
export type StoredProceduresTrackFastGetPostcodeResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastGetPostcode>>>
export type StoredProceduresTrackFastJobsGetChargesBookingResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsGetChargesBooking>>>
export type StoredProceduresTrackFastJobsLookupGetCallTypesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsLookupGetCallTypes>>>
export type StoredProceduresTrackFastJobsLookupGetJobGroupsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsLookupGetJobGroups>>>
export type StoredProceduresTrackFastJobsLookupGetJobTypesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsLookupGetJobTypes>>>
export type StoredProceduresTrackFastJobsLookupGetPaymentMethodsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsLookupGetPaymentMethods>>>
export type StoredProceduresTrackFastJobsLookupGetTradesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsLookupGetTrades>>>
export type StoredProceduresTrackFastJobsSendRequisitionResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsSendRequisition>>>
export type StoredProceduresTrackFastJobsSetupBookingResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsSetupBooking>>>
export type StoredProceduresTrackFastJobsUpdateJobResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsUpdateJob>>>
export type StoredProceduresTrackFastLockingAddLockResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastLockingAddLock>>>
export type StoredProceduresTrackFastLockingGetLockResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastLockingGetLock>>>
export type StoredProceduresTrackFastLockingRemoveLockResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastLockingRemoveLock>>>
export type StoredProceduresTrackFastSearchGetSearchResultResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastSearchGetSearchResult>>>
export type StoredProceduresAppointmentTimeTypesGetResult = NonNullable<Awaited<ReturnType<typeof storedProceduresAppointmentTimeTypesGet>>>
export type StoredProceduresAuditTrailFootprintGetAuditTrailResult = NonNullable<Awaited<ReturnType<typeof storedProceduresAuditTrailFootprintGetAuditTrail>>>
export type StoredProceduresAutoAllocationGetLookupResult = NonNullable<Awaited<ReturnType<typeof storedProceduresAutoAllocationGetLookup>>>
export type StoredProceduresBoilersGetHeatingTypesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresBoilersGetHeatingTypes>>>
export type StoredProceduresBoilersGetManufacturersResult = NonNullable<Awaited<ReturnType<typeof storedProceduresBoilersGetManufacturers>>>
export type StoredProceduresBookingGetBookingRestrictionResult = NonNullable<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestriction>>>
export type StoredProceduresBookingGetBookingRestrictionsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresBookingGetBookingRestrictions>>>
export type StoredProceduresBookingGetLastJobResult = NonNullable<Awaited<ReturnType<typeof storedProceduresBookingGetLastJob>>>
export type StoredProceduresCallMeBacksCancelEnquiryResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksCancelEnquiry>>>
export type StoredProceduresCallMeBacksGetCallMeBackResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksGetCallMeBack>>>
export type StoredProceduresCallMeBacksGetNotesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksGetNotes>>>
export type StoredProceduresCallMeBacksQueuesGetQueueResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksQueuesGetQueue>>>
export type StoredProceduresCallMeBacksSendEmailResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksSendEmail>>>
export type StoredProceduresCallMeBacksSendSMSResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksSendSMS>>>
export type StoredProceduresCallMeBacksSetAsBookedResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksSetAsBooked>>>
export type StoredProceduresCallMeBacksSetCalledResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksSetCalled>>>
export type StoredProceduresCallMeBacksSetFollowUpResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallMeBacksSetFollowUp>>>
export type StoredProceduresCallsGetCurrentCallResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallsGetCurrentCall>>>
export type StoredProceduresCallsGetCurrentCallFive9Result = NonNullable<Awaited<ReturnType<typeof storedProceduresCallsGetCurrentCallFive9>>>
export type StoredProceduresCallsGetDestinationQueueResult = NonNullable<Awaited<ReturnType<typeof storedProceduresCallsGetDestinationQueue>>>
export type StoredProceduresCallsGetDestinationQueueV2Result = NonNullable<Awaited<ReturnType<typeof storedProceduresCallsGetDestinationQueueV2>>>
export type StoredProceduresCallsGetDestinationQueueV3Result = NonNullable<Awaited<ReturnType<typeof storedProceduresCallsGetDestinationQueueV3>>>
export type StoredProceduresDiscountsGetDiscountsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresDiscountsGetDiscounts>>>
export type StoredProceduresEnquiriesQueuesGetQueueResult = NonNullable<Awaited<ReturnType<typeof storedProceduresEnquiriesQueuesGetQueue>>>
export type StoredProceduresEnquiriesSetJobResult = NonNullable<Awaited<ReturnType<typeof storedProceduresEnquiriesSetJob>>>
export type StoredProceduresEventsSetEventResult = NonNullable<Awaited<ReturnType<typeof storedProceduresEventsSetEvent>>>
export type StoredProceduresJobScriptsGetScriptResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobScriptsGetScript>>>
export type StoredProceduresJobsBookingGetIdResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsBookingGetId>>>
export type StoredProceduresJobsCompletionsGetCompletionsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsCompletionsGetCompletions>>>
export type StoredProceduresJobsGetAvailableEngineers2Result = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetAvailableEngineers2>>>
export type StoredProceduresJobsGetHistoryResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetHistory>>>
export type StoredProceduresJobsGetJobResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetJob>>>
export type StoredProceduresJobsGetJobDetailsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetJobDetails>>>
export type StoredProceduresJobsGetJobLinkingResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetJobLinking>>>
export type StoredProceduresJobsGetJobNotesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetJobNotes>>>
export type StoredProceduresJobsGetNotesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetNotes>>>
export type StoredProceduresJobsGetOptionsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetOptions>>>
export type StoredProceduresJobsGetTasksResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsGetTasks>>>
export type StoredProceduresJobsInitialBookingResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsInitialBooking>>>
export type StoredProceduresJobsQuotesGetQuoteResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsQuotesGetQuote>>>
export type StoredProceduresJobsSetChargeResult = NonNullable<Awaited<ReturnType<typeof storedProceduresJobsSetCharge>>>
export type StoredProceduresPropertiesGetBuildingTypesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresPropertiesGetBuildingTypes>>>
export type StoredProceduresReportsSalesAgentScreen4GetResult = NonNullable<Awaited<ReturnType<typeof storedProceduresReportsSalesAgentScreen4Get>>>
export type StoredProceduresServiceAgreementsAPIGetCustomerMatchesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsAPIGetCustomerMatches>>>
export type StoredProceduresServiceAgreementsCheckAvailabilityResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsCheckAvailability>>>
export type StoredProceduresServiceAgreementsGetAvailableOffersResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetAvailableOffers>>>
export type StoredProceduresServiceAgreementsGetAvailableOffersV2Result = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetAvailableOffersV2>>>
export type StoredProceduresServiceAgreementsGetIncentiveResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetIncentive>>>
export type StoredProceduresServiceAgreementsGetIncentiveTypesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetIncentiveTypes>>>
export type StoredProceduresServiceAgreementsGetOfferAllocationReasonsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetOfferAllocationReasons>>>
export type StoredProceduresServiceAgreementsGetPaymentTypesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetPaymentTypes>>>
export type StoredProceduresServiceAgreementsGetPlanCostAfterOffersResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetPlanCostAfterOffers>>>
export type StoredProceduresServiceAgreementsGetPlanCostAfterOffersV2Result = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetPlanCostAfterOffersV2>>>
export type StoredProceduresServiceAgreementsGetServiceAgreementForJobResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetServiceAgreementForJob>>>
export type StoredProceduresServiceAgreementsGetTypeBenefitsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetTypeBenefits>>>
export type StoredProceduresServiceAgreementsGetTypeResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetType>>>
export type StoredProceduresServiceAgreementsGetTypesResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsGetTypes>>>
export type StoredProceduresServiceAgreementsSetCustomerResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsSetCustomer>>>
export type StoredProceduresServiceAgreementsSetServiceAgreementV4Result = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsSetServiceAgreementV4>>>
export type StoredProceduresServiceAgreementsSetServiceAgreementV5Result = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsSetServiceAgreementV5>>>
export type StoredProceduresServiceAgreementsValidateCampaignCodeResult = NonNullable<Awaited<ReturnType<typeof storedProceduresServiceAgreementsValidateCampaignCode>>>
export type StoredProceduresSettingsGetSettingResult = NonNullable<Awaited<ReturnType<typeof storedProceduresSettingsGetSetting>>>
export type StoredProceduresTimeRequirementTypesGetResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTimeRequirementTypesGet>>>
export type StoredProceduresTrackFastAddressBlacklistCheckResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastAddressBlacklistCheck>>>
export type StoredProceduresTrackFastJobsGetCallerResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTrackFastJobsGetCaller>>>
export type StoredProceduresTradesGetJobTypeGroupsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresTradesGetJobTypeGroups>>>
export type StoredProceduresUsersGetStatisticsResult = NonNullable<Awaited<ReturnType<typeof storedProceduresUsersGetStatistics>>>
export type StoredProceduresUsersManagersAuthorisationResult = NonNullable<Awaited<ReturnType<typeof storedProceduresUsersManagersAuthorisation>>>
export type WebBookingGetTop5CallsResult = NonNullable<Awaited<ReturnType<typeof webBookingGetTop5Calls>>>
